import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PuckDataDTO } from 'components/synchrotron/constants';

const initialState: PuckDataDTO[] = Array<PuckDataDTO>();
const PuckSlice = createSlice({
  name: 'pucks',
  initialState,
  reducers: {
    setAllPucks: (state, action: PayloadAction<PuckDataDTO[]>) => {
      return action.payload;
    },
  },
});

export const { setAllPucks } = PuckSlice.actions;

export default PuckSlice.reducer;
